import React from "react";
import "../BlockChain/Blockchain.css";
import { NavLink } from "react-router-dom";
import {
  FiArrowRight,
  FiPenTool,
  FiCompass,
  FiLayers,
  FiFigma,
  FiTarget,
} from "react-icons/fi";

const Graphic = () => {
  return (
    <div className="sub-service-page">
      <div className="page-bg-engine">
        <div className="theme-orb orb-primary"></div>
        <div className="theme-orb orb-secondary"></div>
      </div>
      {/* --- Section 1: Sovereign Hero --- */}
      <section className="sub-hero">
        <div className="v2-container">
          <div className="sub-hero-content">
            <div className="v3-badge">Creative Architecture</div>
            <h1 className="title-reveal">
              Design Systems &{" "}
              <span className="blue-glow">Visual Identity</span>
            </h1>
            <p className="v3-hero-p-centered">
              Crafting bulletproof UI/UX frameworks and world-class digital
              aesthetics that define brand identities in the 2026 landscape.
            </p>
          </div>
        </div>
      </section>

      {/* --- Section 2: Visual Intro --- */}
      <section className="sub-content-section">
        <div className="v2-container">
          <div className="content-layout-left">
            <h2 className="v3-title">
              The Art of <span className="blue-glow">Precision</span>
            </h2>
            <p className="v3-p-text">
              Graphic design is an inventive process that delivers precise
              messages to targeted audiences. We combine creative intuition with
              behavioral data to create visually stunning digital products.
            </p>

            <div className="tech-stack-strip small-icons">
              {["photo.png", "ai.png", "fig.png", "can.png", "co.png"].map(
                (img, i) => (
                  <img src={`/${img}`} alt="tool" key={i} />
                ),
              )}
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 3: Design Pillars --- */}
      <section className="sub-features-section">
        <div className="v2-container">
          <div className="v3-section-head left">
            <h2 className="v3-title">
              Design <span className="blue-glow">Pillars</span>
            </h2>
          </div>

          <div className="feature-grid-sub">
            {[
              {
                icon: <FiPenTool />,
                title: "Brand Identity",
                desc: "Crafting unique visual languages that resonate with global audiences and institutional partners.",
              },
              {
                icon: <FiCompass />,
                title: "UI Engineering",
                desc: "Building intuitive, high-fidelity user interfaces that maximize engagement and conversion.",
              },
              {
                icon: <FiLayers />,
                title: "UX Research",
                desc: "User-centric interaction mapping and wireframing for complex multi-layered applications.",
              },
              {
                icon: <FiFigma />,
                title: "Design Systems",
                desc: "Creating scalable component libraries that ensure consistency across all digital touchpoints.",
              },
              {
                icon: <FiTarget />,
                title: "2D/3D Immersion",
                desc: "Integrating dynamic spatial elements for a truly immersive and modern web experience.",
              },
              {
                icon: <FiLayers />,
                title: "Motion Design",
                desc: "Fluid animations that bring static layouts to life and guide user focus with purpose.",
              },
            ].map((item, idx) => (
              <div className="feature-card-sub" key={idx}>
                <div className="f-icon-box">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- Section 4: Solution Rows --- */}
      <section className="sub-platforms">
        <div className="v2-container">
          <div className="platform-row">
            <div className="platform-text">
              <h2 className="v3-title">
                Spatial <span className="blue-glow">2D & 3D</span>
              </h2>
              <p className="v3-p-text">
                Enhance your digital storefront with captivating animations and
                dynamic spatial markers that engage institutional users with
                immersive depth.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Design Audit <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <FiPenTool
                style={{ fontSize: "10rem", color: "#0066ff", opacity: 0.3 }}
              />
            </div>
          </div>

          <div className="platform-row reverse">
            <div className="platform-text">
              <h2 className="v3-title">
                Iterative <span className="blue-glow">UI/UX</span>
              </h2>
              <p className="v3-p-text">
                Focus on user-centric layouts, navigation, and interactions. We
                conduct rigorous user testing to ensure absolute satisfaction
                and conversion.
              </p>
              <NavLink to="/contactus" className="btn-secondary">
                Initialize Sprint <FiArrowRight />
              </NavLink>
            </div>
            <div className="platform-visual">
              <FiLayers
                style={{ fontSize: "10rem", color: "#6366f1", opacity: 0.3 }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 5: Universal CTA --- */}
      <section className="v3-final-cta">
        <div className="v2-container">
          <div className="v3-cta-card">
            <div className="v3-cta-content">
              <h2 className="v3-cta-title">
                Ready to define <br />
                <span className="grad-blue">your visual future?</span>
              </h2>
              <NavLink to="/contactus" className="v3-main-btn">
                <span>Initialize Studio</span>
                <div className="btn-icon-box">
                  <FiArrowRight />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Graphic;
